import { render, staticRenderFns } from "./LocalRingerModal.vue?vue&type=template&id=b08b0a7e"
import script from "./LocalRingerModal.vue?vue&type=script&lang=js"
export * from "./LocalRingerModal.vue?vue&type=script&lang=js"
import style0 from "./LocalRingerModal.vue?vue&type=style&index=0&id=b08b0a7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports